import type { InvestmentStatus } from "@eu.mdotm.api/sphere";
import type { IconName } from "@mdotm/shadcn/legacy/components";

export const statusIconMap: Record<InvestmentStatus, { icon: IconName; size: number; title: string }> = {
	ERROR: {
		// Temporarily (MDOT-18271) mask Error status as Calculating until BE fixes their process
		// icon: "Close",
		// title: "Error",
		// size: 16,
		icon: "calulating",
		title: "Calculating",
		size: 12,
	},
	READY: {
		icon: "Icon-Ptf-status-SMALL",
		title: "Ready",
		size: 14,
	},
	PROPOSAL_READY: {
		icon: "Icon-full-small",
		title: "Proposal Ready",
		size: 12,
	},
	CALCULATING: {
		icon: "calulating",
		title: "Calculating",
		size: 12,
	},
	EXECUTING: {
		icon: "calulating",
		title: "Executing",
		size: 12,
	},
	ACCEPTED: {
		icon: "Icon-Ptf-status-SMALL",
		title: "Accepted",
		size: 14,
	},
	RETRIEVING_DATA: {
		icon: "calulating",
		size: 12,
		title: "Retrieving data",
	},
	REVIEW: {
		icon: "Edit",
		size: 14,
		title: "Review",
	},
	DRAFT: {
		icon: "Edit",
		size: 14,
		title: "Draft",
	},
};
